'use strict';

const TrueValue = {type: 'icon', value: 'tick'};
const FalseValue = {type: 'icon', value: 'less'};
const serviceIcon = 'odf-li-mark';
const noServiceIcon = 'odf-li-cross odf-text-soft';

const TextValue = function(text) {
    return {type: 'text', value: text};
};

const defaultSettingsDesktop = {
    services: {
        BO_SB: [TrueValue, new TextValue('_additional_price'), FalseValue, FalseValue],
        BO_PB: [TrueValue, TrueValue, FalseValue, TrueValue],
        BO_HB: [TrueValue, FalseValue, TrueValue, FalseValue],
    },

    icons: {
        BO_SB: {
            standard: 'odf-support-small-bag',
            confirmation: 'odf-spot-small-bag-tick',
        },
        BO_PB: {
            standard: 'odf-support-priority-boarding',
            confirmation: 'odf-spot-priority-boarding-tick',
        },
        BO_HB: {
            standard: 'odf-support-check-in-bag',
            confirmation: 'odf-spot-check-in-bag-tick',
        },
    },

    highlightedType: {
        'BO_PB': [
            {
                type: 'BO_PB',
                available: true,
            },
        ],
        'BO_HB': [
            {
                type: 'BO_PB',
                available: false,
            },
            {
                type: 'BO_SB',
                available: true,
            },
        ],
    },

    sortingConditions: [
        {
            type: 'BO_SB',
        },
        {
            isHighlighted: true,
        },
        {
            isHighlighted: false,
        },
    ],
};

const defaultSettingsMobile = {
    services: {
        BO_PB: [
            {keys: ['service1'], icon: serviceIcon},
            {keys: ['service2'], icon: serviceIcon},
            {keys: ['service4'], icon: serviceIcon},
        ],
        BO_HB: [
            {keys: ['service1'], icon: serviceIcon},
            {keys: ['service3', 'service3_desc'], icon: serviceIcon},
        ],
        BO_SB: [
            {keys: ['service1'], icon: serviceIcon},
            {keys: ['service2'], icon: noServiceIcon},
            {keys: ['service3'], icon: noServiceIcon},
            {keys: ['service4'], icon: noServiceIcon},
        ],
    },

    icons: {
        BO_SB: {
            standard: 'odf-support-small-bag',
            confirmation: Odigeo.AB.isCssVariationMobile ? 'odf-spot-small-baggage-warning' : 'odf-spot-small-bag',
        },
        BO_PB: {
            standard: 'odf-support-priority-boarding',
            confirmation: 'odf-spot-priority-boarding-tick',
        },
        BO_HB: {
            standard: 'odf-support-check-in-bag',
            confirmation: 'odf-spot-check-in-bag-tick',
        },
    },

    highlightedType: {
        'BO_PB': [
            {
                type: 'BO_PB',
                available: true,
            },
        ],
        'BO_HB': [
            {
                type: 'BO_PB',
                available: false,
            },
            {
                type: 'BO_SB',
                available: true,
            },
        ],
    },

    sortingConditions: [
        {
            isHighlighted: true,
        },
        {
            available: true,
            type: 'BO_HB',
        },
        {
            available: true,
            type: 'BO_SB',
        },
        {
            available: false,
        },
    ],
};

const getSettings = () => {
    const isMobile = Odigeo.SessionScope.flow === 'mobile';

    const isActiveForOE = Odigeo.AB.isBoardingOptionsOE || Odigeo.AB.isBoardingOptionsOEWithCrossFaring;

    const isActiveForCrossFaringOE = Odigeo.AB.isBoardingOptionsOEWithCrossFaring;

    const isTravelFusionCabinBags = isMobile ? Odigeo.AB.isTravelFusionCabinBagsMobile : Odigeo.AB.isTravelFusionCabinBagsDesktop;

    const defaultSettings = isMobile ? defaultSettingsMobile : defaultSettingsDesktop;
    const ryanairSettings = {fr: defaultSettings};

    const laudamotionSettings = isMobile ? {oe: defaultSettingsMobile} : isActiveForOE ? {oe: defaultSettingsDesktop} : {};

    const ryanairLaudamotionSettings = isMobile ?
        {'fr.oe': defaultSettingsMobile}
        : isActiveForCrossFaringOE ? {'fr.oe': defaultSettingsDesktop} : {};

    if (isTravelFusionCabinBags) {
        return defaultSettings;
    } else {
        return Odigeo._.extend({}, ryanairSettings, laudamotionSettings, ryanairLaudamotionSettings);
    }
};

module.exports = {
    get: getSettings,
};
